import { toast } from "react-toastify";
import React, { useState } from "react";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { OnDataChange } from "@/app/core/util/helpers/FieldHelper";

export default function SignInFormComponent({ closeModal, changeRegister }) {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  
  function handleChange(evt, type) {
    setData(OnDataChange(data, evt, type))
  }

  function login(e) {
    e.preventDefault();
    if(!data.email || !data.password){
      toast.error(Message.PendingData);
    }else{
      if(closeModal != undefined){
        AccountController.Login(data, false, ()=> closeModal());
      }else{
        AccountController.Login(data, true);
      }
    }
  }

  return (
    <div>
      <form
        className="js-validation-signin"
        onSubmit={(e) => login(e)}
      >
        <div className="py-3">
          <input
            className="form-control"
            name="email"
            onChange={(evt) => handleChange(evt)}
            placeholder={"Email"}
            value={data && data.email}
          />
          <input
            className="form-control mt-3"
            name="password"
            onChange={(evt) => handleChange(evt)}
            placeholder={"Senha"}
            value={data && data.password}
          />
        </div>
        <div className="form-group">
          <button
            type="submit"
            className="btn btn-block btn-hero-lg btn-hero-warning"
          >
            <i
              className={
                loading === true
                  ? "fa fa-circle-notch fa-spin"
                  : "fa fa-fw fa-sign-in-alt mr-1"
              }
            />{" "}
            Login
          </button>
          <p className="mt-3 mb-0 text-center">
            <a
              className="btn btn-sm btn-light d-block d-lg-inline-block mb-1"
              onClick={() => (window.location = "#/recuperar-senha")}
            >
              <i className="si si-lock text-muted mr-1" />{" "}
              Recuperar senha
            </a>
          </p>
          <p className="mt-3 mb-0 text-center">
            <a
              className="btn btn-sm btn-light d-block d-lg-inline-block mb-1"
              onClick={() => changeRegister()}
            >
              <i className="fa fa-plus text-muted mr-1" /> Não tem
              conta? Cadastre-se
            </a>
          </p>
        </div>
      </form>
    </div>
  );
}

